import { MDBBtn } from 'mdb-react-ui-kit';
import parse from 'html-react-parser';
import React from 'react'

const StoryContainer = ({showStory, storyData, setShowStory}) => {
  return (
        <div className={`story-container p-5 ${showStory ? 'active' : 'inactive'}`}>
            <MDBBtn outline rounded color='light' className="main-button d-flex justify-content-center align-items-center px-1 py-0 px-3 align-self-start mb-4" onClick={() => setShowStory(false)}>
                <span className="section-button-text py-2">Back</span>
            </MDBBtn>
            <h2 className="story-title mb-4 d-flex align-self-start">{storyData.title}</h2>
            <div className="divider-small mt-2 mb-4"></div>
            <img src={storyData.img} alt="" className="story-image img-fluid"/>
            <div className="story-text my-4">{parse(storyData.description)}</div>
            <div className="divider mt-3 mb-3 d-flex align-self-center"></div> 
        </div>
  )
}

export default StoryContainer
